import React, { Component } from "react";
import { Icon, Radio } from "semantic-ui-react";
import html2canvas from "html2canvas";
import moment from "moment";
import DimmerComponent from "../Dashboard/DimmerComponent";
import { postLikesTabpanes, getFbPostLikesChart } from "./utils";
import { downloadCSVData, downloadCanvasWithTitle } from "../Dashboard/Charts/utils";
import { ReactComponent as MoreOptions } from "../../../assets/svg/menu.svg";
import ChartOptionsSidebar from "../Dashboard/Charts/ChartsOptionsSidebar/ChartOptionsSidebar";
import CustomCheckBox from "../Dashboard/Charts/ChartsOptionsSidebar/CustomCheckBox";
import FBIntervalSelector from "./FBIntervalSelector";
import ChartName from "../Dashboard/Charts/ChartName";
import FBPageSelector from "./FBPageSelector";
import DeleteWidget from "../Dashboard/Charts/ChartsOptionsSidebar/DeleteWidget";
import { ReactComponent as CloneIcon } from "../../../assets/svg/clone-icon.svg";
import { ReactComponent as Settings } from "../../../assets/svg/settings.svg";
import { ReactComponent as ArrowIcon } from "../../../assets/svg/chevron.svg";
import { ChartFilterIcon } from "../Dashboard/Charts/ChartFilterOptions";
import { ReactComponent as MiniMize } from "../../../assets/svg/zoom_in_map.svg";
import { ReactComponent as MaxiMize } from "../../../assets/svg/zoom_out_map.svg";
import Popup from "semantic-ui-react/dist/es/modules/Popup";
import DownloadChart from "../Dashboard/Charts/DownloadChart";
class PostLikesOvertime extends Component {
    constructor(props) {
        super(props);
        this.state = {
            downloading: false,
            showAverage: true,
        };

        this.chart = React.createRef();
    }

    renderDownloadButton(nodata) {
        return (
            <DownloadChart
                nodata={nodata}
                options={[
                    { name: "CSV", downloadFn: this.downloadCSV },
                    { name: "PNG", downloadFn: this.downloadPNG, showLoader: true },
                ]}
            />
        );
    }

    downloadPNG = (cb) => {
        if (this.props.isFreeTierPackage) {
            this.props.packageUpgradePopup();
            return;
        }
        // this.setState({ downloading: true });
        if (this.chart?.current)
            return html2canvas(this.chart.current, { backgroundColor: "#fff", allowTaint: true, useCORS: true, scrollX: 0, scrollY: -window.scrollY }).then(
                (canvas) => {
                    // this.setState({ downloading: false });
                    cb && cb();
                    downloadCanvasWithTitle(canvas, this.props.widget?.name || "Post Reactions");
                },
            );
    };

    downloadCSV = () => {
        if (this.props.isFreeTierPackage) {
            this.props.packageUpgradePopup();
            return;
        }
        this.setState({ downloading: true });
        let data = this.props.data.totalPostLikes;

        let columns;

        columns = [["Time"], ["Like"], ["Angry"], ["Haha"], ["Sad"], ["Love"], ["Wow"]];

        let fields;
        fields = ["likes_agg", "angry_agg", "haha_agg", "sad_agg", "love_agg", "wow_agg"];

        let formatString = "YYYY-MM-DD HH:mm";

        data.likes_agg.map((datArray) => {
            columns[0].push(moment(datArray[0]).format(formatString));
        });

        columns[0].push("Total");

        fields.map((field, index) => {
            let t = 0;
            data[field].map((datArray) => {
                if (datArray) {
                    columns[index + 1].push(datArray[1]);
                    t += datArray[1];
                }
            });
            columns[index + 1].push(t);
        });

        columns[0].push("Average Reactions");
        columns[1].push(data.avg_value);
        columns[2].push("");
        columns[3].push("");
        columns[4].push("");
        columns[5].push("");
        columns[6].push("");

        let csvFmt = columns[0].map((col, i) => columns.map((row) => row[i]));

        this.setState({ downloading: false });
        downloadCSVData(csvFmt, this.props.widget?.name || "Post Reactions");
    };

    increment = () => {
        if (this.props.fbSelectedPageIds.length === 1) return;
        let index;
        this.props.fbSelectedPageIds.map((value, ind) => {
            if (value.id === this.props.selectedFbPage?.value) index = ind;
        });
        if (index === this.props.fbSelectedPageIds.length - 1) this.props.setSelectedFbPage(this.props.fbSelectedPageIds[0]);
        else this.props.setSelectedFbPage(this.props.fbSelectedPageIds[index + 1]);
    };

    decrement = () => {
        if (this.props.fbSelectedPageIds.length === 1) return;
        let index;
        this.props.fbSelectedPageIds.map((value, ind) => {
            if (value.id === this.props.selectedFbPage?.value) index = ind;
        });
        if (index === 0) this.props.setSelectedFbPage(this.props.fbSelectedPageIds[this.props.fbSelectedPageIds.length - 1]);
        else this.props.setSelectedFbPage(this.props.fbSelectedPageIds[index - 1]);
    };

    getChart() {
        let chart = postLikesTabpanes[0].chartsList[0];
        let Component = getFbPostLikesChart(chart).component;
        return (
            <>
                <div className="dashboard-chart dashboard-chart-slider skiptranslate" ref={this.chart}>
                    {!this.props.isFBPage && (
                        <div
                            data-html2canvas-ignore="true"
                            className={`chart-slider chart-slider-left ${this.props.fbSelectedPageIds.length === 1 ? "disabled" : ""}`}
                            onClick={this.decrement}>
                            <ArrowIcon />
                        </div>
                    )}
                    <div className="chart-area">
                        {!this.props.isFBPage && this.props.selectedFbPage && (
                            <FBPageSelector
                                selectedFbPage={this.props.selectedFbPage}
                                setSelectedFbPage={this.props.setSelectedFbPage}
                                fbSelectedPageIds={this.props.fbSelectedPageIds}
                                widgetContainerRef={this.props.widgetContainerRef}
                            />
                        )}

                        <Component
                            showGridLines={this.props.showGridLines}
                            showLegend={this.props.showLegend}
                            graph_type={this.props.graph_type}
                            data={this.props.data?.totalPostLikes}
                            isNoData={this.isNoData}
                            resizedCount={this.props.resizedCount}
                            isFBPage={this.props.isFBPage}
                            widgetContainerRef={this.props.isFBPage ? this.chart : this.props.widgetContainerRef}
                            showAverage={this.state.showAverage}
                            pageStatus={this.props.pageStatus}
                        />
                    </div>
                    {!this.props.isFBPage && (
                        <div
                            data-html2canvas-ignore="true"
                            className={`chart-slider chart-slider-right ${this.props.fbSelectedPageIds.length === 1 ? "disabled" : ""}`}
                            onClick={this.increment}>
                            <ArrowIcon />
                        </div>
                    )}
                </div>
            </>
        );
    }

    isNoData = () => {
        return this.props.pageStatus || this.props.data?.totalPostLikes?.nodata;
    };

    render() {
        const chartOptions = [{ label: "Total Likes", value: 0 }];

        const elements = (
            <>
                <div className="dashboard-widget-container-header skiptranslate">
                    <ChartName
                        isFacebook
                        name={this.props.widget?.name || "Post Reactions"}
                        info="This graph shows the number of times people have engaged with your posts through reactions(like, wow, angry, sad, etc). The average line shows the average reactions per post for posts that were published for the date range selected."
                    />
                    <div className="dashboard-widget-actions" data-html2canvas-ignore="true">
                        {!this.isNoData() && (
                            <div className="chart-type">
                                <span onClick={() => this.props.changeGraphType("bar")} className={this.props.graph_type === "bar" ? "active-chart" : ""}>
                                    <Icon name="bar chart" />
                                </span>
                                <span onClick={() => this.props.changeGraphType("line")} className={this.props.graph_type === "line" ? "active-chart" : ""}>
                                    <Icon name="line chart" />
                                </span>
                            </div>
                        )}
                        {!this.props.isFBPage &&
                            !this.props.isPublic &&
                            !this.props.isResearchDashboard &&
                            this.props.dashboardPageType !== "temporaryInsights" &&
                            this.props.dashboardPageType !== "temporary" && (
                                <ChartFilterIcon
                                    chartFilterApplied={this.props.chartFilterApplied}
                                    changeShowChartFilterOptions={this.props.changeChartFilter}
                                    widgetListDashboardCurrent={this.props.widgetListDashboardCurrent}
                                    name={this.props.widget.name}
                                />
                            )}
                        {!this.props.isPublic && !this.props.isResearchDashboard && !this.isNoData() && this.renderDownloadButton(this.isNoData())}
                        {
                            <>
                                {(this.props.isPublic && this.isNoData()) || this.props.isFBPage ? null : (
                                    <Popup
                                        className="skiptranslate"
                                        trigger={
                                            this.props.expandWidget ? (
                                                <MiniMize className="chart-header-icon" onClick={this.props.expandFullWidget} />
                                            ) : (
                                                <MaxiMize className="chart-header-icon" onClick={this.props.expandFullWidget} />
                                            )
                                        }
                                        inverted
                                        content={this.props.expandWidget ? "Minimize Widget" : "Maximize Widget"}
                                        size="mini"
                                        position="bottom center"
                                        style={{ zIndex: "99999" }}
                                    />
                                )}
                            </>
                        }

                        {this.props.isPublic && this.isNoData() ? null : (
                            <MoreOptions
                                className={this.isNoData() && this.props.isFBPage ? "pointer-disabled" : "more-options"}
                                onClick={(e) => this.props.changeShowMoreOptions(e)}
                            />
                        )}
                    </div>

                    {this.props.showMoreOptions && (
                        <ChartOptionsSidebar
                            data-html2canvas-ignore="true"
                            showMoreOptionsLoc={this.props.showMoreOptionsLoc}
                            changeShowMoreOptions={this.props.changeShowMoreOptions}>
                            {!this.isNoData() && (
                                <>
                                    <CustomCheckBox checked={this.props.showLegend} onClick={this.props.changeShowLegend} label="Show Legends" />
                                    <CustomCheckBox label="Show Grid Lines" checked={this.props.showGridLines} onClick={this.props.changeShowGridLines} />
                                    <CustomCheckBox
                                        label="Show Average"
                                        checked={this.state.showAverage}
                                        onClick={() => this.setState({ showAverage: !this.state.showAverage })}
                                    />
                                    <FBIntervalSelector
                                        aggs_val={this.props.aggs_val}
                                        appliedFilter={this.props.appliedFilter}
                                        handleIntervalChange={this.props.handleIntervalChange}
                                    />
                                </>
                            )}
                            {!this.props.isFBPage &&
                                !this.props.isPublic &&
                                !this.props.isStandardDashboard &&
                                !this.props.isResearchDashboard &&
                                this.props.dashboardPageType !== "temporaryInsights" &&
                                this.props.dashboardPageType !== "temporary" && (
                                    <>
                                        <div className="chart-settings menu-option" onClick={this.props.chartSettings}>
                                            <span>Chart Configuration</span>
                                            <Settings />
                                        </div>
                                        <div className="clone-chart menu-option" onClick={this.props.cloneWidget}>
                                            <span>Clone Chart</span>
                                            <CloneIcon />
                                        </div>
                                        <DeleteWidget onClick={this.props.deleteWidget} />
                                    </>
                                )}
                        </ChartOptionsSidebar>
                    )}
                </div>
                {/* <section key="main-pageview-section" className="notranslate"> */}
                {this.getChart()}
                {(this.state.downloading || !this.props.selectedFbPage || this.props.loading) && <DimmerComponent />}
                {/* </section> */}
            </>
        );

        return this.props.isFBPage ? <div className="dashboard-widget-container">{elements}</div> : <>{elements}</>;
    }
}

export default PostLikesOvertime;
